export default class ZoomTransitionOptions {
    constructor({ startZoomScale, endZoomScale, startAlpha, endAlpha, delay, duration, ease, callbacks } = {}) {
        this.startZoomScale = startZoomScale;
        this.endZoomScale = endZoomScale;
        this.startAlpha = startAlpha;
        this.endAlpha = endAlpha;
        this.delay = delay || 0;
        this.duration = duration || 1000;
        this.ease = ease || createjs.Ease.none;

        if (!callbacks) {
            // No callback is provided
            this.callbacks = [];
        }
        else if (!Array.isArray(callbacks)) {
            // Only 1 callback is provided
            this.callbacks = [callbacks];
        }
        else {
            // Multiple callbacks are provided
            this.callbacks = callbacks;
        }
    };
}